import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const DataGridHook = (props) => {
  const [rows, setRows] = useState([]);
  const [loader, setLoader] = useState(true);
  const navigate = useNavigate();

  const { getMyTickets, ticketsReducer, cleanTicketsAction } = props || {};

  useEffect(() => {
    getMyTickets();
    setLoader(true);
    return () => {
      cleanTicketsAction();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    generateRows();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticketsReducer]);

  const generateRows = () => {
    const { loaded, payload } = ticketsReducer || {};
    if (loaded) {
      const { tickets } = payload || {};
      setLoader(false);

      setRows(tickets);
    }
  };

  const handleNavigate = (params) => {
    if (typeof params?.target?.id !== 'undefined' && typeof params?.target?.name !== 'undefined') {
      const link = '/tickets/' + params.target.id;
      navigate(link, {
        state: { directNumber: params.target.name },
      });
    }
  };
  return {
    handleNavigate,
    generateRows,
    rows,
    loader,
  };
};
